module.exports = __webpack_public_path__ + "static/media/Chad Stutz.004e2805.png";